export default __webpack_public_path__ + "static/Premium-b736818d9bb04bfee0377c6376ce923a.png";